import { Button } from "@mui/material";
import { useState } from "react";
import AlerteDialog from "../../components/AlerteDialog/AlerteDialog";

const AddLotButton = ({
    setOpenModal, disabled = false
}: {
    setOpenModal: React.Dispatch<React.SetStateAction<boolean>>;
    disabled?: boolean;
}) => {
    const [openWarningModal, setOpenWarningModal] = useState<boolean>(false);

    return (
        <>
            <Button
                variant="contained"
                disabled={disabled}
                sx={{ 
                    mr: 2, 
                    bgcolor: 'text.secondary', // Ou ton code couleur hexa direct ex: '#64748b'
                    color: 'white',
                    '&:hover': { bgcolor: '#475569' } // Une nuance plus sombre pour le hover
                }}
                onClick={() => {
                    setOpenWarningModal(true);
                }}
            >
                Ajouter un lot
            </Button>
            {openWarningModal && (
                <AlerteDialog
                open={openWarningModal}
                handleClose={() => setOpenWarningModal(false)}
                deleteProject={() => {
                    setOpenWarningModal(false)
                    setOpenModal(true)
                }}
                title={"ATTENTION : toute modification sur le lot non enregistrée sera perdue !"}
                contentText={"Voulez-vous vraiment quitter la tâche en cours sans sauvergarder ?"}
              />
            )}
        </>
    )
}

export default AddLotButton